import React from 'react';
import cn from 'classnames';
import RectangleSkeleton from "../../../../helpers/Loaders/RectangleSkeleton";
import styles from './ProductTileSkeleton.module.scss';
const ProductTileSkeleton = ({ skeletonClassName, skeletonDetailsArea = true, skeletonCtaArea, }) => {
    return (React.createElement("div", { className: cn(styles.container, skeletonClassName) },
        React.createElement(RectangleSkeleton, { className: cn(styles.imageContainer, styles.grey) }),
        skeletonDetailsArea && (React.createElement("div", { className: styles.detailContainer },
            React.createElement(RectangleSkeleton, { className: cn(styles.detail, styles.grey), height: "12px" }),
            React.createElement(RectangleSkeleton, { className: cn(styles.detail, styles.grey), height: "12px" }),
            React.createElement(RectangleSkeleton, { className: cn(styles.detail, styles.grey), height: "12px" }))),
        !!skeletonCtaArea && (React.createElement(React.Fragment, null,
            React.createElement(RectangleSkeleton, { className: cn(styles.cta, styles.grey), height: "48px" }),
            React.createElement(RectangleSkeleton, { className: cn(styles.cta, styles.grey), height: "48px" })))));
};
export default ProductTileSkeleton;
//# sourceMappingURL=ProductTileSkeleton.js.map